<template>
    <div class="editDialog">
        <el-dialog
            :title="isEdit ? '修改' : '新建'"
            :visible.sync="dialogShow"
            :before-close="handleClose"
            width="700px"
            :close-on-click-modal="false"
        >
            <div class="content">
                <el-form
                    :inline="true"
                    :model="formEdit"
                    label-width="80px"
                    :rules="rules"
                    :ref="refName"
                >
                    <div class="el-form-area">
                        <el-form-item label="名称" prop="name">
                            <el-input v-model="formEdit.name" placeholder="请输入名称" clearable maxlength="20"></el-input>
                        </el-form-item>
                        <el-form-item label="简称" prop="shortName">
                                <el-input v-model="formEdit.shortName" placeholder="请输入简称"></el-input>
                        </el-form-item>
                        <el-form-item label="类型" prop="type">
                            <el-select
                                v-model="formEdit.type"
                                placeholder="请选择类型"
                            >
                                <el-option
                                    v-for="(item, index) in typeList"
                                    :key="index"
                                    :label="item.label"
                                    :value="item.value"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="代理商" prop="agentId">
                            <el-select
                                v-model="formEdit.agentId"
                                placeholder="请选择代理商"
                            >
                                <el-option
                                    v-for="(item, index) in companyList"
                                    :key="index"
                                    :label="item.label"
                                    :value="item.value"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="联系人" prop="contacts">
                            <el-input v-model="formEdit.contacts" placeholder="请输入联系人姓名" maxlength="20"></el-input>
                        </el-form-item>
                        <el-form-item label="联系电话" prop="mobile">
                            <el-input v-model="formEdit.mobile" placeholder="请输入联系电话" maxlength="20"></el-input>
                        </el-form-item>
                        <el-form-item label="邮箱" prop="email">
                            <el-input v-model="formEdit.email" placeholder="请输入邮箱" maxlength="50"></el-input>
                        </el-form-item>
                        <el-form-item class="uploadArea" label="地址" prop="address">
                            <el-input
                                type="textarea"
                                show-word-limit
                                maxlength="100"
                                rows="3"
                                v-model="formEdit.address"
                                placeholder="请输入地址"
                            ></el-input>
                        </el-form-item>
                        <el-form-item class="uploadArea" label="上传封面" prop="logo">
                            <UploadImg
                                v-if="dialogShow"
                                ref="uploadCover"
                                :tip="false"
                                :files="formEdit.logo"
                            />
                        </el-form-item>
                    </div>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handleSubmit">确定</el-button>
                <el-button @click="handleClose">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import editDialogMixin from '@/mixins/editDialogMixin';
import UploadImg from '@/components/Upload/UploadImg';
import { validateTel, validateEmail } from '@/common/validate';
export default {
    mixins: [editDialogMixin],
    components: {
        UploadImg
    },
    props: {
        typeList: {
            type: Array,
            default() {
                return [];
            }
        },
        companyList: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            formReset: {
                id: null,
                name: '',
                shortName: '',
                type:'',
                contacts: '',
                mobile: '',
                email: '',
                address: '',
                agentId: '',
                logo: []
            },
            rules: {
                name: [
                    {
                        required: true,
                        message: '公司名称不能为空',
                        trigger: 'blur'
                    }
                ],
                shortName: [
                    {
                        required: true,
                        message: '公司简称不能为空',
                        trigger: 'blur'
                    }
                ],
                type: [
                    {
                        required: true,
                        message: '公司类型不能为空',
                        trigger: 'blur'
                    }
                ],
                tacts: [
                    {
                        required: true,
                        message: '联系人姓名不能为空',
                        trigger: 'blur'
                    }
                ],
                mobile: [
                    {
                        required: true,
                        message: '联系电话不能为空',
                        trigger: 'blur'
                    },
                    {
                        validator: validateTel,
                        trigger: 'blur'
                    }
                ],
                email: [
                    {
                        validator: validateEmail,
                        trigger: 'blur'
                    }
                ],
                address: [
                    {
                        required: true,
                        message: '公司地址不能为空',
                        trigger: 'blur'
                    }
                ]
            }
        };
    },
    methods: {
        handleSubmit() {
            this.$refs[this.refName].validate(valid => {
                if (valid) {
                    this.$confirm('确认提交吗？', '提示', {
                        type: 'warning'
                    }).then(() => {
                        this.$http
                            .post(
                                this.isEdit
                                    ? '/company/edit/v1'
                                    : '/company/create/v1',
                                {
                                    ...this.formEdit,
                                    logo: this.$refs.uploadCover
                                        .getImgList()
                                        .join(',')
                                },
                                '提交中……',
                                this.isEdit ? '修改成功' : '新建成功'
                            )
                            .then(res => {
                                this.$emit('updateData');
                                this.handleClose();
                            });
                    });
                }
            });
        }
    }
};
</script>